<template>
  <with-invoice :invoice-id="invoiceId">
    <template slot="default" slot-scope="{invoice}">
      <span v-if="invoice.status === 'Draft'">
        <v-tooltip bottom>
            <span slot="activator">
              <v-btn @click="handleShowForm">
                Add all cases without anomalies to invoice
              </v-btn>
            </span>
           Add all cases without anomalies to invoice
        </v-tooltip>

        <v-dialog v-model="showModal" max-width="800" persistent>
          <v-card v-if="showModal">
            <v-card-title class="headline">Add all cases without anomalies to invoice</v-card-title>

            <v-card-text>
              <v-form v-model="isValid" ref="form">
              </v-form>
            </v-card-text>

            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn @click="handleHideForm">Cancel</v-btn>
              <v-btn @click="handleFormSubmit"
                     :disabled="!isSubmitEnabled"
                     :loading="requestInProgress">
                Add
              </v-btn>
            </v-card-actions>
          </v-card>
        </v-dialog>
      </span>
      <span v-else>
        <!--empty-->
      </span>
    </template>
  </with-invoice>
</template>

<script>
  import {mapActions} from "vuex";
  import {notificationService} from "../../../application";
  import WithInvoice from "./WithInvoice";

  function getDefaultFormData() {
    return {}
  }

  export default {
    name: 'attach-cases-without-anomalies-to-invoice-form',
    components: {WithInvoice},
    props: {
      invoiceId: {
        type: Number,
        required: true
      }
    },
    data() {
      return {
        form: getDefaultFormData(),
        showModal: false,
        isValid: false,
        requestInProgress: false,
      }
    },
    watch: {
      showModal() {
        if (!this.showModal) {
          this.resetForm()
        }
      }
    },
    computed: {
      isSubmitEnabled() {
        return this.isValid
      }
    },
    methods: {
      ...mapActions({
        invoiceAttachCasesWithoutAnomaliesToInvoice: 'invoiceAttachCasesWithoutAnomaliesToInvoice',
      }),
      handleShowForm() {
        this.showModal = true
      },
      handleHideForm() {
        this.showModal = false
      },
      handleFormSubmit() {
        if (!this.$refs.form.validate()) {
          return
        }

        const request = {
          invoiceId: this.invoiceId,
        };

        this.requestInProgress = true;

        this
          .invoiceAttachCasesWithoutAnomaliesToInvoice(request)
          .then(() => {
            notificationService.info('Operation success');
            this.resetForm();
            this.requestInProgress = false;
            this.showModal = false
          })
          .catch(e => {
            this.requestInProgress = false;
            notificationService.error('Operation failed');
            throw e
          })
      },
      resetForm() {
        this.form = getDefaultFormData(this.caseInfo)
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/analytics/invoices/AttachCasesWithoutAnomaliesToInvoiceForm.vue